import * as React from "react";
import Select, {Props as SelectProps, GroupBase} from "react-select";
import Creatable, {CreatableProps} from "react-select/creatable";

export interface LabelValueOption {
    label: string
    value: string
}

// React Select Wrapper
export function SelectWrapper<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: SelectProps<Option, IsMulti, Group>) {
  return (
    <Select {...props} className="react-select-container" classNamePrefix="react-select" theme={(theme) => ({ ...theme })} />
  );
}


export function CreatableWrapper<
    Option,
    isMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(props: CreatableProps<Option, isMulti, Group>) {
    return (
        <Creatable {...props} classNamePrefix="react-select"/>
    );
}
